
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteAa as ObiOwnShipRemoteAaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-aa.js';
 
 
 

 
 export const ObiOwnShipRemoteAa = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-aa',
   elementClass: ObiOwnShipRemoteAaElement,
   events: {
     
   }
  });
 
 